import { easyIcon } from './EasyIcon';
import icons from 'virtual:svg-icons-default';

const IconExport = easyIcon(icons.easyExport);

import {
  Setting as IconSetting,
  Delete as IconDelete,
  Refresh as IconRefresh
} from '@element-plus/icons-vue';

// svg 组件缓存
const iconCacheMap = new Map();

const Icons: Record<keyof typeof icons, typeof IconExport> = new Proxy(
  {},
  {
    get(_, prop: string) {
      const name = (icons as any)[prop];
      if (iconCacheMap.has(name)) {
        return iconCacheMap.get(name);
      }

      const component = easyIcon(name);
      iconCacheMap.set(name, component);
      return component;
    }
  }
) as any;

export {
  IconSetting,
  IconExport,
  IconDelete,
  IconRefresh,
  Icons,
  icons as IconNames
};
